import { Button, Grid, TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiTextField-root": {
            margin: theme.spacing(1),
            width: "150ch",
        },
        flexGrow: 1,
    },
    button: {
        margin: theme.spacing(1),
    },
}));

const GetAccessToken = () => {
    const classes = useStyles();
    const [accessToken, setAccessToken] = useState("");
    const textAreaRef = useRef(null);
    const { t } = useTranslation("translation");

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));

        if (oktaToken && oktaToken.accessToken) {
            setAccessToken("Bearer " + oktaToken.accessToken.accessToken);
        }
    }, []);

    const CopyToClipboard = (e) => {
        textAreaRef.current.select();
        document.execCommand("copy");
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField style={{ marginTop: 25 }} id="standard-multiline-flexible" label="Access Token" multiline value={accessToken} inputRef={textAreaRef} />
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={CopyToClipboard} className={classes.button} startIcon={<LibraryAddIcon />}>
                        {t("Copy")}
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

export default GetAccessToken;
